@let blok = block();
@let showTooltipData = showTooltip();

<dfn
    class="s1-tooltip__dnf"
    role="button"
    tabindex="0"
    [attr.aria-describedby]="id"
    (focus)="showTooltip.set(true)"
    (blur)="showTooltip.set(false)"
    (mouseenter)="showTooltip.set(true)"
    (mouseleave)="showTooltip.set(false)"
>
    i
</dfn>

@if (showTooltipData) {
    <div
        class="s1-tooltip__inner-div"
        [attr.id]="id"
        role="tooltip"
    >
        {{ blok.text }}
        <div class="s1-tooltip__triangle"></div>
    </div>
}
